import React, { FC } from 'react';
import { withWebHeader } from '@24i/nxg-sdk-smartott/src/navigation/components/withWebHeader';
import { CleengPaymentHistory } from '../../../CleengPaymentHistory';

const CleengPaymentHistoryScreenView: FC = () => {
    return <CleengPaymentHistory />;
};

export default withWebHeader(CleengPaymentHistoryScreenView);
